import { FC } from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';

// interface that extends GridCellProps
interface PhoneNumberCellProps extends GridCellProps {
  linked?: boolean;
}

const PhoneNumberCell: FC<React.PropsWithChildren<PhoneNumberCellProps>> = ({ dataItem, field, linked }) => {
  const phone = dataItem[field];
  const formattedTelNumber = `${phone.slice(0, 3)}.${phone.slice(3, 6)}.${phone.slice(6)}`;
  const formattedPhoneNumber = `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`;
  return (
    <td>
      {phone && (
        <>
          {linked ? (
            <a href={`tel:${formattedTelNumber}`} className="text-link">
              {formattedPhoneNumber}
            </a>
          ) : (
            formattedPhoneNumber
          )}
        </>
      )}
    </td>
  );
};

export default PhoneNumberCell;
